import { BaseHttpController } from './BaseHttpController';

const endpoint = 'static-map';

export class StaticMapController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getStaticMapForShipment(shipmentId: number): Promise<string> {
    const response = await this.http.get<string>(`${shipmentId}`);
    return response.data;
  }
}
